// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1TDLI","label":"styles_label__EqSvV"};